module.exports = __webpack_public_path__ + "static/1.c0ec5156.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/work/dlgsc/img/1.png
// module id = ./src/pages/work/dlgsc/img/1.png
// module chunks = 3360190947491456000